enum EstadosDetallesFormulario {
    CREACION = 'CREACION',
    EDICION = 'EDICION',
}

export default EstadosDetallesFormulario;
